import { ISearchQuery } from "../../../shared/hooks/useSearch"
import { AddCaseToMeetingActionTypes, IFetchCasesAddableToMeetingsAsyncAction } from "./addCaseToMeetingTypes"

export const fetchCasesAddableToMeetingsAsync = (searchQuery: ISearchQuery): IFetchCasesAddableToMeetingsAsyncAction => {
  return {
    type: AddCaseToMeetingActionTypes.FETCH_CASES_ADDABLE_TO_MEETINGS_ASYNC_PENDING,
    payload: searchQuery
  }
}
